import { pluralizeWithCount } from "@/lib/utils";

window.pluralizeWithCount = pluralizeWithCount;
